import UserCard from '@/components/user/dashboard/pages/user-card/user-card.vue'
import SubscribeNews from '@/components/user/dashboard/pages/subscribe-news/subscribe-news.vue'

export default {
    components: {
        UserCard,
        SubscribeNews
    },
    computed: {
        isEditProfile() {
            return this.$route.name === 'Profile' || this.$route.name === 'Edit Junior Profile';
        }
    },
    methods: {
        getCardClasses() {
            return {
                'col-lg-3': true,
                'pl-0': true,
                'pr-0': true,
                'mr-0': true,
                'pr-0': true,
                'md-hidden': !this.isEditProfile,
                'col-sm-6 col-xs-12': this.isEditProfile,
            };
        }
    },
    mounted() {
    }
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/content/content.js